export default __webpack_public_path__ + "static/media/instaicon.b5b9638c.svg";